import { capitalizeFirstLetters } from "../utils/stringUtils";
import { mapFabricData } from "../utils/fabricUtils";
import FabricCard from "./FabricCard";

const FabricList = ({ filteredFabrics, selectedShade }) => (
	<div className="w-full my-4 max-lg:w-11/12 mx-auto">
		{Object.entries(filteredFabrics).map(([series, data], index) => (
			<div key={index} className="text-center">
				<hr className="!divider" />
				<div className="flex flex-col justify-center my-10 items-center mx-4">
					<h2 className="text-3xl font-bold mr-1 px-4">
						{capitalizeFirstLetters(series)}
					</h2>
					<h3 className="text-base font-bold text-[#424242]">
						{capitalizeFirstLetters(data.group)}
					</h3>
				</div>
				<FabricCard
					fabricData={data.fabrics.map(mapFabricData)}
					seriesData={series.toLowerCase()}
					selectedShade={selectedShade.toLowerCase()}
				/>
			</div>
		))}
	</div>
);

export default FabricList;
